import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalEmittersService } from './global-emitters.service';
import { ManagementApiService } from './management-api.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserUtilityService } from './user-utility.service';

@Injectable({
    providedIn: 'root',
})
export class NavigateUrlService {
    constructor(
        private router: Router,
        private globalEmittersService: GlobalEmittersService,
        private managementApiService: ManagementApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private userUtilityServices: UserUtilityService
    ) {}

    navigateUrl(url: string) {
        switch (url) {
            case 'Home':
                this.router.navigate(['home']);
                break;
            case 'Standard Flange':
                this.globalEmittersService.selectedCalcType.next(url.replace(/\s/g, '').toLowerCase());
                this.router.navigate(['/informate/standardflange/false']);
                break;
            case 'Custom Flange':
                this.globalEmittersService.selectedCalcType.next(url.replace(/\s/g, '').toLowerCase());
                this.router.navigate(['/informate/customflange/false']);
                break;
            case 'Clamp':
                this.globalEmittersService.selectedCalcType.next(url.replace(/\s/g, '').toLowerCase());
                this.router.navigate(['/informate/clamp/false']);
                break;
            case 'Engineered Joint':
                this.globalEmittersService.selectedCalcType.next(url.replace(/\s/g, '').toLowerCase());
                this.router.navigate(['/informate/engineeredjoint/false']);
                break;
            case 'Matrix':
                this.router.navigate(['/informate/matrix']);
                break;
            case 'Plant Manager':
                this.router.navigate(['/idms/plantmanager']);
                break;
            case 'Project Manager':
                this.router.navigate(['/idms/project-manager']);
                break;
            case 'Reports':
                this.router.navigate(['/idms/reports']);
                break;
            case 'Dashboard':
            case 'idms':
                this.router.navigate(['/idms/dashboard']);
                break;
            case 'Ice Database':
                this.router.navigate(['informate/icedatabase']);

                break;
            default:
                this.router.navigate(['home']);
                break;
        }
    }

    getInstancesByOrgId(orgId: string, instancename: string) {
        this.ngxUiLoaderService.start();
        this.managementApiService.getInstanceByOrgId(orgId).subscribe(
            (instances) => {
                this.ngxUiLoaderService.stop();
                if (instances.success === true) {
                    if (instances) {
                        const instanceslist = instances.response;
                        const selectedinstance = instanceslist.filter((x) => x.name == instancename);
                        this.globalEmittersService.currentInstanceName.next(selectedinstance[0].name);
                        this.globalEmittersService.currentInstanceId.next(selectedinstance[0].instanceId);
                        this.globalEmittersService.currentInstanceTypeId.next(selectedinstance[0].instanceType.instanceTypeId);
                        localStorage.setItem('currentInstanceName', selectedinstance[0].name);
                        localStorage.setItem('currentInstanceTypeName', selectedinstance[0].instanceType.name);
                        localStorage.setItem('currentInstanceId', selectedinstance[0].instanceId);
                        localStorage.setItem('selectedInstanceDetails', JSON.stringify(selectedinstance[0]));
                        if (selectedinstance[0] && selectedinstance[0].instanceAssetType && selectedinstance[0].instanceAssetType.name) {
                            localStorage.setItem('currentAssetType', selectedinstance[0].instanceAssetType.name);
                        }
                        this.router.navigate(['/home']);
                    }
                } else {
                    this.userUtilityServices.errorModelPopup(instances.message);
                }
            },
            (error) => {
                this.ngxUiLoaderService.stop();
            }
        );
    }
}
